import styled from '@emotion/styled';

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[4],
}));
